import { useState } from "react";
import api, { formatDate, formatINR } from "@/lib/api";
import Navbar from "@/components/quickwash/Navbar";
import Footer from "@/components/quickwash/Footer";
import { Search, CheckCircle2, Circle, Loader2 } from "lucide-react";

const steps = ["Received", "Processing", "Dry Cleaning", "Ironing", "Ready", "Out for Delivery", "Delivered"];

const Track = () => {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);

  const search = async (e) => {
    e.preventDefault();
    if (q.trim().length < 3) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/track?q=${encodeURIComponent(q.trim())}`);
      setResults(data);
    } catch { setResults([]); } finally { setLoading(false); }
  };

  return (
    <div className="bg-[#F8FAFC] min-h-screen flex flex-col">
      <Navbar />
      <div className="qw-container py-14 lg:py-20 flex-1">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-3">Order Tracking</div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900" style={{ fontFamily: 'Poppins' }}>Track your Quick Wash order</h1>
            <p className="text-slate-600 mt-3">Enter your bill number or mobile number.</p>
          </div>
          <form onSubmit={search} className="qw-card p-3 flex gap-2" data-testid="track-form">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="e.g. QW1024 or 9876543210" className="qw-input border-none focus:ring-0" data-testid="track-input"/>
            <button disabled={loading} type="submit" className="qw-btn-primary shrink-0" data-testid="track-submit">
              {loading ? <Loader2 size={18} className="animate-spin"/> : <Search size={18}/>} Track
            </button>
          </form>

          {results && results.length === 0 && (
            <div className="qw-card p-8 mt-6 text-center text-slate-500" data-testid="track-empty">No orders found for "{q}"</div>
          )}
          {results && results.map((bill) => (
            <div key={bill.id} className="qw-card p-6 mt-6" data-testid={`track-result-${bill.bill_number}`}>
              <div className="flex justify-between items-start mb-6">
                <div>
                  <div className="text-xs uppercase text-slate-500 font-semibold">Bill Number</div>
                  <div className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Poppins' }}>{bill.bill_number}</div>
                  <div className="text-sm text-slate-600 mt-1">{bill.customer_name} · {bill.mobile}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs uppercase text-slate-500 font-semibold">Amount</div>
                  <div className="text-xl font-bold text-slate-900">{formatINR(bill.grand_total)}</div>
                  <div className="text-xs text-slate-500 mt-1">Delivery {formatDate(bill.delivery_date)}</div>
                </div>
              </div>
              <div className="space-y-3">
                {steps.map((s, idx) => {
                  const currentIdx = steps.indexOf(bill.status);
                  const done = idx <= currentIdx;
                  return (
                    <div key={s} className="flex items-center gap-3">
                      {done ? <CheckCircle2 size={20} className="text-emerald-500"/> : <Circle size={20} className="text-slate-300"/>}
                      <span className={done ? "text-slate-900 font-medium" : "text-slate-400"}>{s}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Track;
